import loadable from '@loadable/component';

export default loadable(() => import(/* webpackChunkName: "zendesk-chat" */ './ZendeskChat'));
